<script setup lang="ts" name="RegistrationSelectedOptions">
import FilterTag from '~/components/FilterTag.vue';
import RegistrationSelectionLayout from '~/components/RegistrationSelectionLayout.vue';

import type { IRegistrationHighlightedOption } from '~/types';

const { selectedOptions } = defineProps<{
  selectedOptions: IRegistrationHighlightedOption[];
  variant: 'minimal' | 'default';
}>();

const emit = defineEmits<{
  (e: 'clearFilter', option: IRegistrationHighlightedOption): void;
}>();
</script>

<template>
  <RegistrationSelectionLayout
    data-test="registration-search-selected-options"
    title="You have searched for:"
    :variant="variant"
  >
    <FilterTag
      v-for="option in selectedOptions"
      :key="option.id"
      :name="option.name"
      @click="emit('clearFilter', option)"
    />
  </RegistrationSelectionLayout>
</template>
